/** Creates an array of unique array values not included in the other provided arrays using SameValueZero for equality comparisons.
 * @param array - The array to inspect
 * @param values -The arrays of values to exclude
 * @return The new array of filtered values
 */

export const difference = <T>(array: T[], values: T[]): T[] =>
    [array, values].reduce((a, b) => a.filter((c) => !b.includes(c)));
